import type { ScopeFilterOptions } from '../hooks/useScopeFilterOptions';

/** Props compartidas del filtro de alcance en Plan de demanda e hipótesis (misma UX). */
export function sopEntityScopeFilterBarOptions(scope: ScopeFilterOptions) {
  return {
    families: scope.familyOptions,
    subfamilies: scope.subfamilyOptions,
    suppliers: scope.supplierOptions,
    showSubfamily: true as const,
    showProduct: true as const,
    showWarehouse: false as const,
  };
}
